import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import { toast } from "@/services/Utils";

const BasicConfirm = ({
	showConfirm,
	setShowConfirm,
	handleActionCancel,
	handleAction,
	message,
	subMessage,
	onlyReview,
	textConfirm,
	textCancel,
	showValidation,
	textValidation,
	isOverlay = false,
}) => {
	const { addToast } = useToasts();

	const [validateText, setValidateText] = useState("");

	const handleClose = () => {
		setValidateText("");
		setShowConfirm(false);
	};

	const handleConfirm = () => {
		if (showValidation) {
			if (textValidation) {
				if (textValidation === validateText) {
					setValidateText("");
					handleAction();
				} else {
					toast(addToast, "Para completar la acción debe ingresar el texto indicado.", "error");
				}
			} else {
				if ("confirmar" === validateText) {
					setValidateText("");
					handleAction();
				} else {
					toast(addToast, "Para completar la acción debe ingresar el texto indicado.", "error");
				}
			}
		} else {
			setValidateText("");
			handleAction();
		}
	};

	const handleCancel = () => {
		if (handleActionCancel) {
			setValidateText("");
			handleActionCancel(false);
		} else {
			setValidateText("");
			handleClose();
		}
	};

	const buttonEnter = (e) => {
		if (e.key === "Enter") {
			handleConfirm();
		}
	};

	const modalStyle = isOverlay ? { backgroundColor: "#00000073", display: "block", zIndex: 1050 } : { backgroundColor: "#00000073", display: "block" };

	return (
		<Modal show={showConfirm} onHide={handleClose} backdrop="static" keyboard={false} style={modalStyle}>
			<div>
				<Modal.Header closeButton>
					<Modal.Title style={{ fontSize: "1em" }}>{message ? message : "¿Está seguro de que desea realizar esta acción?"}</Modal.Title>
				</Modal.Header>
				{(subMessage || showValidation) && (
					<Modal.Body style={{ padding: "15px 11px" }}>
						<div></div>
						{subMessage && <div style={{ fontSize: "13px" }}>{subMessage}</div>}

						{showValidation && (
							<div style={{ fontSize: "13px", paddingTop: "10px" }}>
								Para completar la acción escribe a continuación el siguiente texto{" "}
								<strong>
									<i>{textValidation ? textValidation : "confirmar"}</i>
								</strong>
								<Form.Control
									style={{ marginTop: "10px" }}
									value={validateText}
									onChange={(e) => setValidateText(e.target.value)}
									type="text"
									onKeyDown={(e) => buttonEnter(e)}
								/>
							</div>
						)}
					</Modal.Body>
				)}
				<Modal.Footer>
					{!onlyReview && (
						<Button style={{ fontSize: "0.8em" }} variant="danger" onClick={() => handleCancel()}>
							{textCancel ? textCancel : "CANCELAR"}
						</Button>
					)}
					<Button style={{ fontSize: "0.8em" }} variant="success" onClick={() => handleConfirm()}>
						{textConfirm ? textConfirm : "CONFIRMAR"}
					</Button>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default BasicConfirm;
